/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const OctagonPause = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M10 15V9" }],
    ["path", { d: "M14 15V9" }],
    ["path", { d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714z" }]
  ]
];

export { OctagonPause as default };
//# sourceMappingURL=octagon-pause.js.map
